import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useAttrs, watch } from "vue"
import { COUNTRIES as _COUNTRIES, ICountry } from "../../../constants/data"
import { PhoneInput as PhoneInputType } from "@/gql"
import { extend, ValidationObserver } from "vee-validate"
import parsePhoneNumber from "libphonenumber-js"


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneInput',
  props: {
    value: null,
    label: null,
    required: { type: Boolean },
    labelEndAdornment: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: PhoneInputType
  label?: string
  required?: boolean
  labelEndAdornment?: string
}

extend("dialcode_required", {
  params: ["target"] as const,
  validate(_, { target }: Record<string, any>) {
    return target ? true : false
  },
  message: "Please select country code",
})

const isPhoneNumberValid = (val: string) => {
  if (!selectedCountry.value) return false
  const parsedPhoneNumber = parsePhoneNumber(val, selectedCountry.value.code)

  return parsedPhoneNumber?.isValid() || false
}

extend(
  "validate_phone_number",
  (value: string) => isPhoneNumberValid(value) || "Please enter a valid phone number"
)





const COUNTRIES = _COUNTRIES
const selectedCountry = ref<ICountry | null>(null)

const form = ref({
  number: "",
  countryCode: "",
})

const numberProvider = ref<InstanceType<typeof ValidationObserver> | null>(null)

const numberValidation = computed(() => {
  const validationString = "dialcode_required:@dialCode|validate_phone_number"
  return props.required ? `required|${validationString}` : validationString
})

const currentErrors = computed(() => {
  return numberProvider.value ? (numberProvider.value as any).errors : []
})

const attrs = computed(() => {
  const { label, prependIcon, ...attrs } = useAttrs()
  return attrs
})

const getItemText = (item: ICountry) => `${item.flag} ${item.en} (${item.dialCode})`

const onChange = () => {
  emit("input", form.value)
}
const onDialCodeChange = (cn: ICountry) => {
  if (!cn) return
  form.value.countryCode = cn.dialCode
  selectedCountry.value = cn
  onChange()
}

watch(
  props,
  (newProps) => {
    if (newProps.value) {
      form.value = { ...newProps.value }

      const country = COUNTRIES.find((country) => country.dialCode === form.value.countryCode)
      if (!country) return
      selectedCountry.value = country
    }
  },
  {
    immediate: true,
  }
)

return { __sfc: true,isPhoneNumberValid, emit, props, COUNTRIES, selectedCountry, form, numberProvider, numberValidation, currentErrors, attrs, getItemText, onChange, onDialCodeChange }
}

})